// extracted by mini-css-extract-plugin
export default {"insuranceCertificates":"PhZqQWwzp4yT6GX35pMG"};